// extracted by mini-css-extract-plugin
module.exports = {"quickShopLink":"ry-z","button":"sy-z","disabled":"ty-z","noReviews":"uy-z"};